<!-- 企业认证页面 -->
<template>
  <div class="certification">
    <v-head></v-head>
    <div class="cert-body-wrap">
      <div class="cert-content-wrap">
        <div class="cert-block-item">
          <h3>单位信息</h3>
          <ul class="cert-form-ul">
            <li class="cert-form-li">
              <span class="cert-form-title">单位名称</span>
              <div class="cert-form-content">
                <el-input placeholder="请输入单位名称" v-model="corporateInfo.name" maxlength="30"></el-input>
              </div>
              <span class="cert-form-tips">{{corporateInfo.name.length}} / 30 字</span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">单位简称</span>
              <div class="cert-form-content">
                <el-input placeholder="请输入单位简称" v-model="corporateInfo.short_name" maxlength="8"></el-input>
              </div>
              <span class="cert-form-tips">{{corporateInfo.short_name.length}} / 8字</span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">单位简介</span>
              <div class="cert-form-content">
                <el-input
                  type="textarea"
                  rows="5"
                  v-model="corporateInfo.company_profile"
                  placeholder="请输入单位简介"
                  maxlength="300"
                ></el-input>
              </div>
              <span class="cert-form-tips">{{corporateInfo.company_profile.length}} / 300字</span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">单位区域</span>
              <div class="cert-form-content">
                <el-cascader v-model="areaInfo" :options="areaList" style="width:100%"></el-cascader>
              </div>
              <span class="cert-form-tips"></span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">详细地址</span>
              <div class="cert-form-content">
                <el-input maxlength="100" placeholder="请输入详细地址" v-model="corporateInfo.address"></el-input>
              </div>
              <span class="cert-form-tips"></span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">单位授权人</span>
              <div class="cert-form-content">
                <el-input placeholder="请输入授权人姓名" maxlength="30" v-model="corporateInfo.authorizer"></el-input>
              </div>
              <span class="cert-form-tips"></span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">授权人身份证号</span>
              <div class="cert-form-content">
                <el-input placeholder="请输入授权人身份证号" v-model="corporateInfo.authorizer_idcard"></el-input>
              </div>
              <span class="cert-form-tips"></span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">
                <span class="title-name">固定电话</span>
                <span class="title-tips">（选填）</span>
              </span>
              <div class="cert-form-content">
                <el-input placeholder="请输入固定电话" maxlength="30" v-model="corporateInfo.telephone"></el-input>
              </div>
              <span class="cert-form-tips"></span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">单位性质</span>
              <div class="cert-form-content">
                <el-select
                  v-model="corporateInfo.business_nature"
                  style="width:100%"
                  placeholder="请选择单位性质"
                >
                  <el-option
                    v-for="item in natureList"
                    :label="item.value"
                    :key="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <span class="cert-form-tips"></span>
            </li>
            <li class="cert-form-li">
              <span class="cert-form-title">企业LOGO</span>
              <div class="cert-form-content">
                <div class="step-conten">
                  <ul class="upload-wrap">
                    <li
                      v-if="logoway === 1"
                      class="logo-default"
                      :style="{ backgroundImage:'url('+defaultLogoUrl+')'}"
                    ></li>
                    <li v-else class="uploadLogo">
                      <el-upload
                        :data="qiniuData"
                        :show-file-list="false"
                        :before-upload="beforeLOGOUpload"
                        :on-success="uploadSuccess"
                        accept="image/jpg, image/jpeg, image/png"
                        :action="action"
                      >
                        <div class="logo-wrap" :style="{ backgroundImage:'url('+logourl+')'}">
                          <el-icon class="el-icon-camera-solid" />
                          <span>上传LOGO</span>
                        </div>
                      </el-upload>
                    </li>
                  </ul>
                </div>
                <div class="step-conten">
                  <el-radio-group v-model="logoway" size="mini">
                    <el-radio :label="1">使用默认LOGO</el-radio>
                    <el-radio :label="2">上传LOGO</el-radio>
                  </el-radio-group>
                </div>
                <p class="cert-form-tips">上传图片比例为1：1，格式为JPG，文件需小于200KB</p>
              </div>
              <span class="cert-form-tips"></span>
            </li>
          </ul>
        </div>
        <div class="cert-block-item part-2">
          <h3>主体信息</h3>
          <div class="part-2-item">
            <h4 class="part2-title">1、上传营业执照</h4>
            <div class="part-item-content">
              <span class="part-item-title">认证方式</span>
              <div class="inner-wrap-c">
                <el-radio-group v-model="corporateInfo.approveType" size="mini">
                  <el-radio :label="1">社会信用代码</el-radio>
                  <el-radio :label="2">营业执照</el-radio>
                  <el-radio :label="3">非营利机构</el-radio>
                </el-radio-group>
              </div>
              <div class="inner-wrap-r"></div>
            </div>
            <div class="part-item-content">
              <span class="part-item-title">营业执照</span>
              <div class="inner-wrap-c">
                <el-upload
                  :data="qiniuData"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadSuccessyyzz"
                  accept="image/jpeg', 'image/jpg"
                  :action="action"
                >
                  <div
                    class="wrap-c-upload"
                    :style="{ backgroundImage:'url('+corporateInfo.business_licence+')'}"
                  >
                    <el-icon class="el-icon-camera-solid" />
                    <span>上传营业执照</span>
                  </div>
                </el-upload>
                <p>上传营业执照照片</p>
                <p>支持JPG格式照片，大小不超过500KB</p>
              </div>
              <div class="inner-wrap-r">
                <div class="exmp-demo demo1"></div>
                <a>参考示例</a>
              </div>
            </div>
            <h4 class="part2-title" style="margin-top:40px;">
              2、下载
              <a href="../../../static/authorizationLetter.docx" download="授权函.docx">《授权函》</a>填写并盖章后上传扫描件
            </h4>
            <div class="part-item-content">
              <span class="part-item-title">授权函</span>
              <div class="inner-wrap-c">
                <el-upload
                  :data="qiniuData"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="uploadSuccesssqh"
                  accept="image/jpeg', 'image/jpg"
                  :action="action"
                >
                  <div
                    class="wrap-c-upload"
                    :style="{ backgroundImage:'url('+corporateInfo.authorization+')'}"
                  >
                    <el-icon class="el-icon-camera-solid" />
                    <span>上传授权函</span>
                  </div>
                </el-upload>
                <p>上传授权函照片</p>
                <p>支持JPG格式照片，大小不超过500KB</p>
              </div>
              <div class="inner-wrap-r">
                <div class="exmp-demo demo2"></div>
                <a>参考示例</a>
              </div>
            </div>
          </div>
        </div>
        <div class="form-button-wrap">
          <button class="submit-button" @click="submit">提交</button>
          <button class="cancel-button" @click="cancel">取消</button>
        </div>
      </div>
    </div>
    <!-- footer -->
    <my-footer></my-footer>
  </div>
</template>

<script>
import vFooter from '@/components/footer/footer.vue'
import { dateformat, isIdAvailable } from '@/util/utils.js'
import vHead from '@/components/header/header.vue'
import {
  Input,
  Cascader,
  Icon,
  Radio,
  RadioGroup,
  Upload,
  Select,
  Option, Loading
} from 'element-ui'
export default {
  name: 'certification',
  components: {
    'v-head': vHead,
    'my-footer': vFooter,
    'el-input': Input,
    'el-cascader': Cascader,
    'el-icon': Icon,
    'el-radio': Radio,
    'el-radio-group': RadioGroup,
    'el-upload': Upload,
    'el-select': Select,
    'el-option': Option
  },
  data () {
    return {
      logourl: '',
      defaultLogoUrl: 'https://devpic.nauac.com/20190815/07167d9f5d0b4ca88b9669a9cbc784ba.jpg',
      logoway: 1,
      regnzway: 1,
      areaList: [],
      areaInfo: [],
      natureList: [
        {
          value: '国家机关',
          label: '国家机关'
        },
        {
          value: '事业单位',
          label: '事业单位'
        },
        {
          value: '有限责任公司',
          label: '有限责任公司'
        },
        {
          value: '股份有限公司',
          label: '股份有限公司'
        },
        {
          value: '合伙企业',
          label: '合伙企业'
        }
      ],
      corporateInfo: {
        name: '',
        short_name: '',
        company_profile: '',
        address: '',
        authorizer: '',
        authorizer_idcard: '',
        telephone: '',
        business_licence: '',
        authorization: '',
        business_nature: '',
        approveType: 1
      },
      qiniuData: {
        key: '', // 图片名字处理
        token: '', // 七牛云token
        putExtra: {
          fname: '',
          mimeType: ['image/jpeg', 'image/jpg']
        }
      }
    }
  },
  created () {
    this.getAreaList()
    this.getQiniuToken()
    this.getCertifiInfo()
  },
  methods: {
    getCertifiInfo () {
      if (this.userInfo.reviewStatus === '2') {
        this.$http({
          method: 'POST',
          url: 'enterprise/getEnterpriseByUserid'
        }).then(res => {
          if (res.code === 100 || res.code === '100') {
            this.corporateInfo = res.result
            this.logourl = res.result.logo
            if (this.logourl !== '') {
              this.logoway = 2
            } else {
              this.logoway = 1
            }
            if (res.result.area_id && res.result.area_id !== '') {
              this.areaInfo = [res.result.country_id, res.result.province_id, res.result.city_id, res.result.area_id]
            } else {
              this.areaInfo = [res.result.country_id, res.result.province_id, res.result.city_id]
            }
            delete this.corporateInfo.admin
            delete this.corporateInfo.comefrom
            delete this.corporateInfo.createby
            delete this.corporateInfo.createdate
            delete this.corporateInfo.delflag
            delete this.corporateInfo.platAdmin
            delete this.corporateInfo.review_status
            delete this.corporateInfo.updateby
            delete this.corporateInfo.updatedate
            delete this.corporateInfo.userMobile
            delete this.corporateInfo.userid
            delete this.corporateInfo.username
          } else {
            this.$alert(res.msg || '数据异常，请稍后重试')
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    submit () {
      let item = this.corporateInfo
      let url = '/enterprise/addEnterprise'
      if (this.userInfo.reviewStatus === '2') {
        url = '/enterprise/recertification'
      }
      if (this.formcheck()) {
        let country = this.findItemName(this.areaList, this.areaInfo[0])
        let province = this.findItemName(country.children, this.areaInfo[1])
        let city = this.findItemName(province.children, this.areaInfo[2])
        let area = this.findItemName(city.children, this.areaInfo[3])

        item.country_name = country.label
        item.province_name = province.label
        item.city_name = city.label
        item.area_name = area.label

        item.country_id = this.areaInfo[0] || ''
        item.province_id = this.areaInfo[1] || ''
        item.city_id = this.areaInfo[2] || ''
        item.area_id = this.areaInfo[3] || ''

        item.logo = this.logoway === 2 ? this.logourl : ''
        this.$http({
          method: 'POST',
          url: url,
          params: item
        }).then(res => {
          if (res.code === 100 || res.code === '100') {
            this.$alert('企业认证申请已成功提交，请耐心等待审核，审核成功后将在站内心中发送通知，请关注站内信动态。', {
              type: 'success',
              confirmButtonText: '确定'
            })
            this.$router.push({ path: '/' })
          } else {
            this.$alert(res.msg || '数据异常，请稍后重试', '提示信息', { type: 'warning' })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    cancel () {
      this.$router.push({ path: '/' })
    },
    findItemName (arr, val) {
      for (let i in arr) {
        if (arr[i].value === val) {
          return arr[i]
        }
      }
      return []
    },
    // 上传之前头像验证
    beforeLOGOUpload (file) {
      let mimeType = ['image/jpeg', 'image/jpg']
      var _this = this
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isLt200KB = file.size / 1024 < 200
      return new Promise((resolve, reject) => {
        _this.testWidthHeight(file, 300, 300, function (isWH) {
          if (!isJPG) {
            _this.$message.error('上传图片只能是 JPG/JPEG 格式!')
            reject(new Error('上传图片只能是 JPG/JPEG 格式!'))
            return false
          }
          if (!isLt200KB) {
            _this.$message.error('上传图片大小不能超过 200KB!')
            reject(new Error('上传图片大小不能超过 200KB!'))
            return false
          }
          if (!isWH) {
            _this.$message.error('上传图片尺寸比例必须为1：1!')
            reject(new Error('上传图片尺寸比例必须为1：1!'))
            return false
          }
          if (isJPG && isLt200KB && isWH) {
            _this.qiniuData.key = _this.getRandomKey(file)
            _this.qiniuData.putExtra.fname = file.name
            _this.qiniuData.putExtra.mimeType = mimeType
            _this.loading = Loading.service({
              lock: true,
              text: '正在上传',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            resolve()
          } else {
            reject(new Error('fileformat is illegal'))
          }
        })
      })
    },
    testWidthHeight (file, W, H, callback) {
      var isAllow = false
      if (file) {
        // 读取图片数据
        var reader = new FileReader()
        reader.addEventListener('load', function () {
          var data = reader.result
          // 加载图片获取图片真实宽度和高度
          var image = new Image()
          image.src = data
          image.onload = function () {
            var width = image.width
            var height = image.height
            isAllow = width === height
            callback && callback(isAllow)
          }
          image.error = function () {
            callback && callback(isAllow)
          }
        }, false)
        reader.readAsDataURL(file)
      } else {
        callback && callback(isAllow)
      }
    },
    // 上传之前图片验证
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 < 500

      if (!isJPG) {
        this.$message.error('图片只能是JPG/JPEG格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过500KB!')
        return false
      }
      this.qiniuData.key = this.getRandomKey(file)
      this.qiniuData.putExtra.fname = file.name
      // if (isJPG && isLt2M) {
      //   this.loadHeaderImg = true
      // }

      this.loading = Loading.service({
        lock: true,
        text: '正在上传',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return isJPG && isLt2M
    },
    // 上传成功
    uploadSuccess (response, file, fileList) {
      this.loading.close()
      this.logourl = response.url
    },
    // 上传成功
    uploadSuccessyyzz (response, file, fileList) {
      this.loading.close()
      this.corporateInfo.business_licence = response.url
    },
    // 上传成功
    uploadSuccesssqh (response, file, fileList) {
      this.loading.close()
      this.corporateInfo.authorization = response.url
    },
    // 请求后台拿七牛云token
    getQiniuToken () {
      this.$http({
        method: 'POST',
        baseURL: this.commonapi + '/pic',
        url: 'qiniu/ent/token/get',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        params: {
          userId: 1,
          moduleName: '企业展示端-认证',
          sourceType: 3
        }
      }).then(res => {
        if (res.code === '100') {
          this.qiniuData.token = res.data.token
        } else {
          this.$message.error('请求失败')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 随机生成上传图片Key
    getRandomKey (filelist) {
      let uuidname = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      var index1 = filelist.name.lastIndexOf('.')
      var index2 = filelist.name.length
      var suffix = filelist.name.substring(index1, index2)
      var fileName = dateformat(new Date(), 'yyyyMMdd') + '/' + uuidname + suffix
      return fileName
    },
    formcheck () {
      if (this.corporateInfo.name === '') {
        this.$message.info('请填写单位名称')
        return false
      }
      if (this.corporateInfo.short_name === '') {
        this.$message.info('请填写单位简称')
        return false
      }
      if (this.corporateInfo.company_profile === '') {
        this.$message.info('请填写单位介绍')
        return false
      }
      if (this.areaInfo.length === 0) {
        this.Message.info('请选择单位所在区域')
        return false
      }
      if (this.corporateInfo.address === '') {
        this.$message.info('请填写详细地址')
        return false
      }
      if (this.corporateInfo.authorizer === '') {
        this.$message.info('请填写单位授权人')
        return false
      }
      if (this.corporateInfo.authorizer_idcard === '') {
        this.$message.info('请输入单位授权人身份证号')
        return false
      }
      if (!isIdAvailable(this.corporateInfo.authorizer_idcard)) {
        this.$message.info('身份证号格式不正确')
        return false
      }
      if (this.corporateInfo.business_nature === '') {
        this.$message.info('请选择单位性质')
        return false
      }
      if (this.logoway !== 1 && this.logourl === '') {
        this.$message.info('请上传您的LOGO，或选择默认LOGO')
        return false
      }
      if (this.corporateInfo.business_licence === '') {
        this.$message.info('请上传营业执照照片')
        return false
      }
      if (this.corporateInfo.authorization === '') {
        this.$message.info('请上传授权函照片')
        return false
      }
      return true
    },
    getAreaList () {
      this.$http({
        method: 'POST',
        url: '/common/getArea'
      }).then(res => {
        if (res.code === 100) {
          this.areaList = res.result
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}

</script>

<style src='./certification_native.scss' lang='scss'></style>
<style src='./certification.scss' lang='scss' scoped></style>



// WEBPACK FOOTER //
// src/views/certification/certification.vue